import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { CompanySettingForm } from "~/components/specifics/settings/admin/company_settings/CompanySettingForm";
import type { ItandiAccount } from "~/models/ItandiAccount";

type Props = {
	currentCompany: Exclude<ItandiAccount["company"], null>;
};

export function Page({ currentCompany }: Props) {
	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader title="会社設定" />
					<PanelBody>
						<CompanySettingForm companySetting={currentCompany} />
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
